export default __webpack_public_path__ + "static/Afro-c46d46862d91457f23c2c87bcbf3d833.svg";